const pricingStateChanged = (state) => ({
  type: "pricing/pricingUIStateChange",
  state: state,
});

const PricingActions = {
  pricingStateChanged,
};

export default PricingActions;
